import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';
import { ContactDetails } from '@futrli-sdk/predict';

import { fetchCustomersAndSuppliers, fetchCustomersAndSuppliersDetails } from '../../predict/src/core/api/customers-and-suppliers';
import { queryClient } from '../core/queryClient';

type FetchContactsResult = Awaited<ReturnType<typeof fetchCustomersAndSuppliers>>;
type ContactsQueryOptions = Omit<QueryObserverOptions<FetchContactsResult>, 'queryKey' | 'queryFn'>;
type ContactDetailQueryOptions = Omit<QueryObserverOptions<ContactDetails>, 'queryKey' | 'queryFn'>;

export const contactsQueryKey = (organisationId: string, workspaceId: string, period: string) => [
  'contacts',
  organisationId,
  workspaceId,
  period
];

export const contactDetailQueryKey = (organisationId: string, workspaceId: string, contactId: string) => [
  'contactDetail',
  organisationId,
  workspaceId,
  contactId
];

export const contactsQuery = (
  workspaceId: string,
  organisationId: string,
  period: string,
  options?: ContactsQueryOptions
): QueryObserver<FetchContactsResult> =>
  new QueryObserver<FetchContactsResult>(queryClient, {
    queryKey: contactsQueryKey(organisationId, workspaceId, period),
    queryFn: () => fetchCustomersAndSuppliers(workspaceId, organisationId, { period }),
    enabled: !!period,
    ...options
  });

export const contactDetailQuery = (
  workspaceId: string,
  organisationId: string,
  contactId: string,
  contactType: string,
  options?: ContactDetailQueryOptions
): QueryObserver<ContactDetails> =>
  new QueryObserver<ContactDetails>(queryClient, {
    queryKey: contactDetailQueryKey(organisationId, workspaceId, contactId),
    queryFn: () => fetchCustomersAndSuppliersDetails(workspaceId, organisationId, contactId, { type: contactType }),
    enabled: false,
    ...options
  });
